app.factory('miscService', ['$q', '$rootScope', '$http', '$ocLazyLoad', 'broadcastService', '$filter', '$modal', 'displayService',
    function ($q, $rootScope, $http, $ocLazyLoad, broadcastService, $filter, $modal, displayService)
{
        let miscServiceFactory = {};


        let _compileAppliedDoc_by_mod = function (val, module) {

            if (val == "" || val == undefined) {
                return "";
            }

            let allNum = val.split(",");
            let newString = "";

            for (var tmd = 0; tmd < allNum.length; tmd++) {
                let text = allNum[tmd];
                let Key = text.substring(0, text.indexOf("_"));
                let ouCode = text.substring(text.indexOf("_") + 1, text.indexOf("@"));
                let Source = text.substring(text.indexOf("@") + 1, text.indexOf("&"));
                let docNum = text.substring(text.indexOf("&") + 1, text.length);

                newString = newString + '<a style="font-weight: bold;text-decoration: underline;cursor: pointer;" ng-click="openTrans('
                    + "'" + module + "'," +
                    Key + ",\'" + Source + "\'" + ')" > ' + docNum + ' (' + ouCode + ') </a>'
                    + " ,"

            }

            if (newString.length > 0) {
                newString = newString.substring(0, newString.length - 2);
            }

            return newString;
        }


        miscServiceFactory.compileAppliedDoc_by_MOD = _compileAppliedDoc_by_mod;

        return miscServiceFactory;
}]);